﻿import * as React from "react";
import { Checkbox } from "@material-ui/core";
import { ICommPreference } from ".";

export interface IPreferenceItemProps extends ICommPreference {
    updateParent: (id: number, email: boolean, notification: boolean) => void;
}

export const PreferenceItem: React.FunctionComponent<IPreferenceItemProps> = (
    props,
): React.ReactElement => {
    const handleEmailChange = (
        event: React.ChangeEvent<HTMLInputElement>,
    ): void => {
        const email: boolean = event.target.checked;

        let notification: boolean = props.notification;

        if (!email && !notification) {
            notification = true;
        }

        props.updateParent(props.id, email, notification);
    };

    const handleNotificationChange = (
        event: React.ChangeEvent<HTMLInputElement>,
    ): void => {
        const notification: boolean = event.target.checked;

        let email: boolean = props.email;

        if (!notification && !email) {
            email = true;
        }

        props.updateParent(props.id, email, notification);
    };

    return (
        <tr>
            <td>
                <h4 className={`preferenceitem-title`}>{props.name}</h4>
                <p className={`preferenceitem-para`}>{props.description}</p>
            </td>
            <td>
                <Checkbox
                    checked={props.email}
                    checkedIcon={
                        <img
                            className={`icon-image`}
                            src={`/Images/UI/RadioButtonChecked.svg`}
                        />
                    }
                    className={`preferenceitem-checkbox`}
                    icon={
                        <img
                            className={`icon-image`}
                            src={`/Images/UI/RadioButtonUnchecked.svg`}
                        />
                    }
                    onChange={handleEmailChange}
                />
            </td>
            <td>
                <Checkbox
                    checked={props.notification}
                    checkedIcon={
                        <img
                            className={`icon-image`}
                            src={`/Images/UI/RadioButtonChecked.svg`}
                        />
                    }
                    className={`preferenceitem-checkbox`}
                    icon={
                        <img
                            className={`icon-image`}
                            src={`/Images/UI/RadioButtonUnchecked.svg`}
                        />
                    }
                    onChange={handleNotificationChange}
                />
            </td>
        </tr>
    );
};
